import { useQuery } from '@tanstack/react-query'
import { ConfigHttpClient, ConfigResponse } from '@omnea-app/config/configHttpClient'
import { GlobalIntegration } from '@omnea-app/config/globalIntegrations'
import { useAuthenticatedUser } from '@omnea-app/fe-auth/UserSessionProvider'
import { isDefined } from '@omnea-app/legacy/utils/type-guard/isDefined'
import { throwIfApiError } from '@omnea-app/packages/universal/error-handling/throwifApiError'
import { organisationIntegrationsQueryKey } from './organisationIntegrationsQueryKey'

type ListOrganisationIntegrationResponseType = ConfigResponse<'/integrations', 'get'>
type ListOrganisationIntegrationsData = ListOrganisationIntegrationResponseType['data']
type ListOrganisationIntegrationsError = ListOrganisationIntegrationResponseType['error']
export type OrganisationIntegration = NonNullable<ListOrganisationIntegrationsData>[number]

export const useListOrganisationIntegrations = ({
  enabled = true,
  type,
}: { enabled?: boolean; type?: GlobalIntegration } = {}) => {
  const { getToken } = useAuthenticatedUser()

  return useQuery<ListOrganisationIntegrationsData, ListOrganisationIntegrationsError>({
    queryKey: isDefined(type) ? [organisationIntegrationsQueryKey, type] : [organisationIntegrationsQueryKey],
    enabled,
    queryFn: async () => {
      const apiClient = new ConfigHttpClient({ authorization: await getToken() })
      const { data, error } = await apiClient.GET('/integrations', { params: { query: { type } } })
      throwIfApiError(error)
      return data
    },
  })
}
